<div class="d-flex flex-column" style="gap:10px">
    <button mat-flat-button class="btn-action btn-with-icon" color="accent" (click)="addImage()"><img
        style="width:25px;" src="/assets/img/add-rekbot.png" alt=""> Dodaj media</button>
    <table mat-table [dataSource]="dataSource" matSort class="common-table">
        <!-- name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>

        <!-- file_name Column -->
        <ng-container matColumnDef="file_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Plik</th>
            <td mat-cell *matCellDef="let element"> {{element.fileName}} </td>
        </ng-container>

        <!-- hash Column -->
        <ng-container matColumnDef="hash">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>HASH</th>
            <td mat-cell *matCellDef="let element"> {{element.hash}} </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> </th>
            <td class="action-cell" mat-cell *matCellDef="let element">
                <div class="d-flex flex-row">
                    <div class="d-flex" style="gap:5px;">
                        <a  class="btn btn-primary btn-action"  color="accent" target="_blank" [href]="element.url"
                            matTooltip="Pokaż"><mat-icon aria-hidden="false" aria-label="Pokaż"
                                >remove_red_eye</mat-icon></a>
                        <button type="button" class="btn btn-primary btn-action" (click)="edit(element)"
                            matTooltip="Edytuj"><mat-icon aria-hidden="false" aria-label="Edytuj"
                                fontIcon="edit"></mat-icon></button>
                        <button type="button" class="btn btn-danger btn-action" (click)="remove(element)"
                            matTooltip="Usuń"><mat-icon aria-hidden="false" aria-label="Usuń">delete</mat-icon></button>

                    </div>

                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>